(function() {
  function initTabScrollSwitch() {
    if (window.innerWidth >= 750) return;

    const section = document.querySelector('.section-tabs-collection-with-slideshow');
    if (!section) return;

    const productGrids = section.querySelectorAll('.scroll-wrapper .custom-product-grid');
    if (!productGrids.length) return;

    const tabs = section.querySelectorAll('#Slider-tabs-collection li');
    if (!tabs.length) return;

    const blockCollections = section.querySelectorAll('.block__collection');
    if (!blockCollections.length) return;

    const SCROLL_THRESHOLD = 20;
    let scrollTimeout = null;
    const DEBOUNCE_TIME = 150;
    let lastTabSwitchTime = 0;
    const TAB_SWITCH_COOLDOWN = 300;

    const scrollGestureTracker = new Map(); // { grid: { startTime, startScrollLeft, attempts } }

    let isProgrammaticScroll = false;

    const gridScrollState = new Map();

    function getCurrentActiveTabIndex() {
      const activeTab = section.querySelector('#Slider-tabs-collection li.active');
      if (!activeTab) return 0;

      let index = 0;
      tabs.forEach((tab, i) => {
        if (tab === activeTab) index = i;
      });
      return index;
    }

    function switchToTab(tabIndex) {
      if (tabIndex < 0 || tabIndex >= tabs.length) return;

      const targetTab = tabs[tabIndex];
      if (!targetTab) return;

      const tabsSlider = section.querySelector('#Slider-tabs-collection');
      const tabsSliderComponent = section.querySelector('.slider-tabs-title');
      const sliderCounter = section.querySelector('.slider-tabs-title .slider-counter--current');
      const tabsDots = section.querySelectorAll('.tabs-title-dots .slider-dot');

      targetTab.click();

      setTimeout(() => {
        if (sliderCounter) {
          sliderCounter.textContent = tabIndex + 1;
        }

        tabsDots.forEach((dot, i) => {
          if (i === tabIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });

        if (tabsSlider && targetTab) {
          const tabOffsetLeft = targetTab.offsetLeft;
          const tabWidth = targetTab.offsetWidth;
          const sliderWidth = tabsSlider.clientWidth;
          const currentScroll = tabsSlider.scrollLeft;

          const tabCenter = tabOffsetLeft + tabWidth / 2;
          const viewportCenter = currentScroll + sliderWidth / 2;
          const scrollDiff = tabCenter - viewportCenter;
          const scrollPosition = currentScroll + scrollDiff;

          const maxScroll = tabsSlider.scrollWidth - sliderWidth;
          const finalScroll = Math.max(0, Math.min(scrollPosition, maxScroll));

          tabsSlider.scrollTo({
            left: finalScroll,
            behavior: 'smooth'
          });

          if (tabsSliderComponent && typeof tabsSliderComponent.update === 'function') {
            setTimeout(() => {
              tabsSliderComponent.update();
            }, 200);
          }
        }
      }, 50);
    }

    function handleScrollEnd(grid, blockIndex) {
      if (isProgrammaticScroll) {
        return;
      }

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      scrollTimeout = setTimeout(() => {
        const { scrollLeft, scrollWidth, clientWidth } = grid;
        const maxScroll = scrollWidth - clientWidth;

        let scrollState = gridScrollState.get(grid);
        if (!scrollState) {
          scrollState = {
            lastScrollLeft: scrollLeft,
            lastScrollTime: Date.now(),
            hasTriggeredEnd: false,
            hasTriggeredStart: false
          };
          gridScrollState.set(grid, scrollState);
        }

        const previousScrollLeft = scrollState.lastScrollLeft;

        const scrollDelta = scrollLeft - previousScrollLeft;
        const isScrollingRight = scrollDelta > 0;
        const isScrollingLeft = scrollDelta < 0;
        const isScrolling = Math.abs(scrollDelta) > 1;

        scrollState.lastScrollLeft = scrollLeft;
        scrollState.lastScrollTime = Date.now();

        if (!isScrolling) {
          return;
        }

        const now = Date.now();
        if (now - lastTabSwitchTime < TAB_SWITCH_COOLDOWN) {
          return;
        }

        const isAtEnd = scrollLeft >= maxScroll - SCROLL_THRESHOLD;
        const isAtStart = scrollLeft <= SCROLL_THRESHOLD;
        const currentTabIndex = getCurrentActiveTabIndex();

        if (isScrollingRight && scrollState.hasTriggeredStart) {
          scrollState.hasTriggeredStart = false;
        }
        if (isScrollingLeft && scrollState.hasTriggeredEnd) {
          scrollState.hasTriggeredEnd = false;
        }

        if (isAtEnd && isScrollingRight && currentTabIndex < tabs.length - 1) {
          if (scrollState.hasTriggeredEnd) {
            return;
          }

          let gesture = scrollGestureTracker.get(grid);
          if (!gesture) {
            gesture = { startTime: now, startScrollLeft: scrollLeft, attempts: 0 };
            scrollGestureTracker.set(grid, gesture);
          }

          gesture.attempts++;

          const timeSinceStart = now - gesture.startTime;
          const hasScrollDelta = scrollDelta >= 15;
          const hasMultipleAttempts = gesture.attempts >= 2 && timeSinceStart < 300;

          if (!hasScrollDelta && !hasMultipleAttempts) {
            return;
          }

          scrollGestureTracker.delete(grid);
          scrollState.hasTriggeredEnd = true;
          scrollState.hasTriggeredStart = false;
          lastTabSwitchTime = now;

          switchToTab(currentTabIndex + 1);

          setTimeout(() => {
            const nextBlock = blockCollections[currentTabIndex + 1];
            if (nextBlock) {
              const nextGrid = nextBlock.querySelector('.custom-product-grid');
              if (nextGrid) {
                isProgrammaticScroll = true;
                nextGrid.scrollLeft = 0;

                gridScrollState.delete(grid);
                const newState = {
                  lastScrollLeft: 0,
                  lastScrollTime: Date.now(),
                  hasTriggeredEnd: false,
                  hasTriggeredStart: false
                };
                gridScrollState.set(nextGrid, newState);

                setTimeout(() => {
                  isProgrammaticScroll = false;
                }, 200);
              }
            }
          }, 50);
        }

        if (!isAtEnd) {
          if (scrollState.hasTriggeredEnd) {
            scrollState.hasTriggeredEnd = false;
          }
          scrollGestureTracker.delete(grid);
        }

        if (isAtStart && isScrollingLeft && currentTabIndex > 0 && blockIndex === currentTabIndex) {
          if (scrollState.hasTriggeredStart) {
            return;
          }

          let gesture = scrollGestureTracker.get(grid);
          if (!gesture) {
            gesture = { startTime: now, startScrollLeft: scrollLeft, attempts: 0 };
            scrollGestureTracker.set(grid, gesture);
          }

          gesture.attempts++;

          const timeSinceStart = now - gesture.startTime;
          const hasScrollDelta = Math.abs(scrollDelta) >= 15;
          const hasMultipleAttempts = gesture.attempts >= 2 && timeSinceStart < 300;

          if (!hasScrollDelta && !hasMultipleAttempts) {
            return;
          }

          scrollGestureTracker.delete(grid);
          scrollState.hasTriggeredStart = true;
          scrollState.hasTriggeredEnd = false;
          lastTabSwitchTime = now;

          switchToTab(currentTabIndex - 1);

          setTimeout(() => {
            const prevBlock = blockCollections[currentTabIndex - 1];
            if (prevBlock) {
              const prevGrid = prevBlock.querySelector('.custom-product-grid');
              if (prevGrid) {
                isProgrammaticScroll = true;
                const { scrollWidth, clientWidth } = prevGrid;
                const maxScroll = scrollWidth - clientWidth;
                prevGrid.scrollLeft = maxScroll;

                gridScrollState.delete(grid);
                const newState = {
                  lastScrollLeft: maxScroll,
                  lastScrollTime: Date.now(),
                  hasTriggeredEnd: false,
                  hasTriggeredStart: false
                };
                gridScrollState.set(prevGrid, newState);

                setTimeout(() => {
                  isProgrammaticScroll = false;
                }, 200);
              }
            }
          }, 50);
        }

        if (!isAtStart) {
          if (scrollState.hasTriggeredStart) {
            scrollState.hasTriggeredStart = false;
          }
          scrollGestureTracker.delete(grid);
        }
      }, DEBOUNCE_TIME);
    }

    productGrids.forEach((grid, index) => {
      const blockCollection = grid.closest('.block__collection');
      if (!blockCollection) return;

      let blockIndex = -1;
      blockCollections.forEach((block, i) => {
        if (block === blockCollection) blockIndex = i;
      });

      if (blockIndex === -1) return;

      if (!gridScrollState.has(grid)) {
        const { scrollLeft } = grid;
        gridScrollState.set(grid, {
          lastScrollLeft: scrollLeft,
          lastScrollTime: Date.now(),
          hasTriggeredEnd: false,
          hasTriggeredStart: false
        });
      }

      grid.addEventListener(
        'scroll',
        () => {
          handleScrollEnd(grid, blockIndex);
        },
        { passive: true }
      );
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth >= 750) return;
      }, 250);
    });
  }

  function waitForElements() {
    const section = document.querySelector('.section-tabs-collection-with-slideshow');
    const productGrids = section?.querySelectorAll('.scroll-wrapper .custom-product-grid');

    if (section && productGrids && productGrids.length > 0) {
      initTabScrollSwitch();
    } else {
      setTimeout(waitForElements, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(waitForElements, 100);
    });
  } else {
    setTimeout(waitForElements, 100);
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail.sectionId === '{{ section.id }}') {
      setTimeout(initTabScrollSwitch, 200);
    }
  });
})();
